import { takeEvery, put, select } from 'redux-saga/effects'
import _get from 'lodash/get'
import {
  PAIDLEAVE_GET_LOCATION_DETAILS
} from './actionTypes'
import { companyID } from '../account/selectors'
import { api } from '../common/helpers'
import {
  setLocation
} from './actions'

function * getLocationDetailsData (data) {
  const company = yield select(companyID)
  const apiResponse = yield api({
    api: `companies/${company}/locations/${data.payload.id}/paidleave/details`,
    params: {}
  })

  if (!apiResponse.error) {
    yield put(setLocation(apiResponse.data))
  }
}

export default function * paidLeaveSaga () {
  yield takeEvery(PAIDLEAVE_GET_LOCATION_DETAILS, getLocationDetailsData)
}
